import { useScrollProgress } from "../hooks";
import { HeatPump } from "./HeatPump";

const clamp = (v) => Math.min(Math.max(v, 0), 1);
const lerpColor = (p) => {
  const a = [109, 90, 240], b = [16, 164, 122];
  const c = a.map((x, i) => Math.round(x + (b[i] - x) * p));
  return `rgb(${c[0]},${c[1]},${c[2]})`;
};

export const CaseStudies = () => {
  const [ref, progress] = useScrollProgress();

  const p1 = clamp(progress / 0.3);
  const pt = clamp((progress - 0.3) / 0.35);
  const p2 = clamp((progress - 0.65) / 0.3);

  const telecomStyle = {
    opacity: 1 - pt * 3.2,
    transform: `translateY(${(1 - p1) * 60 - pt * 160}px) scale(${1 - pt * 0.15})`,
    pointerEvents: pt > 0.3 ? "none" : "auto",
  };
  const transitionStyle = {
    opacity: pt > 0.12 && p2 < 0.9 ? Math.min((pt - 0.12) * 3.4, 1) * (1 - clamp((p2 - 0.35) * 3)) : 0,
    transform: `scale(${0.85 + pt * 0.15})`,
    pointerEvents: "none",
  };
  const energyStyle = {
    opacity: (p2 - 0.25) * 2.4,
    transform: `translateY(${(1 - p2) * 140}px)`,
    pointerEvents: p2 < 0.4 ? "none" : "auto",
  };

  return (
    <section className="cases-outer" id="results" data-testid="cases-section" ref={ref} style={{ height: "380vh" }}>
      <div className="cases-sticky">
        <div className="case-panel" style={telecomStyle} data-testid="case-telecom">
          <div className="case-card telecom">
            <span className="eyebrow" style={{ color: "#a99bff" }}>Case study — Telecom</span>
            <h3>$10M+ generated for TELUS in under 2 years</h3>
            <p>
              With over 5 years of experience in telecommunications sales, Swift Marketing has been a
              key partner in helping TELUS expand across Quebec. Our team deployed high-performing sales
              representatives across in-person, phone, and digital channels — strengthening TELUS's local
              presence and generating over $10 million in new revenue with lasting customer retention.
            </p>
            <div className="case-stats">
              <div className="case-stat"><div className="v">$10M+</div><div className="k">New revenue</div></div>
              <div className="case-stat"><div className="v">&lt;2 yrs</div><div className="k">Timeframe</div></div>
              <div className="case-stat"><div className="v">3</div><div className="k">Channels deployed</div></div>
            </div>
          </div>
        </div>

        <div className="case-transition" style={transitionStyle} data-testid="case-transition">
          <HeatPump
            power
            mode={pt > 0.5 ? "heat" : "cool"}
            bladeRotation={progress * 2200}
            glow={lerpColor(pt)}
            width={360}
          />
          <h3>
            <span className="same">Same machine</span> — <span className="new">New market</span>
          </h3>
          <div className="sub">Telecom playbook · redeployed into energy</div>
        </div>

        <div className="case-panel" style={energyStyle} data-testid="case-energy">
          <div className="case-card energy-case">
            <span className="eyebrow green">Case study — Swift Energy</span>
            <h3>$300K in signed thermo pump sales in 2 months</h3>
            <p>
              An unknown brand with bad reviews and zero social media presence asked us to prove the
              model. We deployed a trained field team into Quebec neighbourhoods and closed $300,000
              in signed thermo pump contracts within 60 days — no ads, no followers, just conversations
              at the door.
            </p>
            <div className="case-stats">
              <div className="case-stat"><div className="v">$300K</div><div className="k">Signed sales</div></div>
              <div className="case-stat"><div className="v">2 mo</div><div className="k">Timeframe</div></div>
              <div className="case-stat"><div className="v">0</div><div className="k">Social followers needed</div></div>
            </div>
          </div>
        </div>

        <div className="case-progress">
          <i className={p1 > 0.2 ? "on" : ""} />
          <i className={pt > 0.3 ? "on" : ""} />
          <i className={p2 > 0.3 ? "on g" : ""} />
        </div>
      </div>
    </section>
  );
};
